import { useCallback } from 'react';
import api from './api';

/**
 * Hook for tracking tool usage analytics
 * Usage:
 *   const { trackView, trackGenerate, trackDownload, trackShare } = useAnalytics('whatsapp-link');
 *   trackView(); // When page loads
 *   trackGenerate({ linkType: 'wa.me' }); // When user generates something
 */
export const useAnalytics = (toolName) => {
  const track = useCallback(async (action, metadata = null) => {
    try {
      await api.post('/analytics/track', {
        tool_name: toolName,
        action,
        metadata
      });
    } catch (error) {
      // Silently fail - don't interrupt user experience for analytics
      console.debug('Analytics tracking failed:', error);
    }
  }, [toolName]);

  return {
    trackView: useCallback((metadata) => track('view', metadata), [track]),
    trackGenerate: useCallback((metadata) => track('generate', metadata), [track]),
    trackDownload: useCallback((metadata) => track('download', metadata), [track]),
    trackShare: useCallback((metadata) => track('share', metadata), [track]),
    trackAction: track
  };
};

export default useAnalytics;
